module.exports = __webpack_public_path__ + "static/media/nessun.96bb55ab.svg";